import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=2b71ae26&scoped=true&"
import script from "./Bank.vue?vue&type=script&lang=js&"
export * from "./Bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71ae26",
  null
  
)

export default component.exports